const Lang={
    "en":{
        "nsl":"Nicosia Sailing Club",
        "yes":"yes",
        "no":"no",
        "intro":"High Speed Small Vessel Operator's License Examination System",
        "selectlanguage":"Select Language",
        "clickonsmslink":"Click on the link you received via SMS",
        "registersuccess":"You successfully registered for",
        "unregistersuccess":"You successfully unregistered from",
        "confirmation":"Confirmation",
        "confexaminedon":"Confirm you would like to register to be examined on",
        "confexaminedonnote":"",
        "confunregisterfrom":"Confirm you would like to unregister from examination on",
        "examined":"Examined",
        "registeredfor":"Registered to be examined on",
        "notregisteredfor":"Not registered to be examined",
        "license":"Licence",
        "expires":"Expires",
        "personaldetails":"Personal Details",
        "status":"Status",
        "instructionsprefix":"Please read imporant instructions regarding the exams",
        "instructions":"Exams instructions",
        "usernotfound":"User not found",
        "nextaction":"Next Action",
        "registertobeexamined":"Register to be examined on one of the available dates below",
        "availableseats":"Available seats",
        "register":"Register",
        "cantmakeit":"Can't make it?",
        "cantmakeittext":"If you are unable to attend, you must unregister in time. Failure to unregister will result in failing the exam in which case you may have to apply and pay again to re-take the exam.",
        "unregister":"Unregister",
        "nodates":"No Seats Available",
        "nodatestext":"There are no more seats available for the upcoming examination dates. We will announce new examination dates soon and you will be notified via SMS.",
        "moreinfoemail":"For more information please email us at:",
        "orvisitwebsite":"or visit our website",
    },
    "gr":{
        "nsl":"Ιστιοπλοϊκός Όμιλος Λευκωσίας",
        "yes":"ναι",
        "no":"οχι",
        "intro":"Σύστημα Εξετάσεων Άδειας Χειριστή Ταχύπλοου Σκάφους",
        "selectlanguage":"Επιλέξτε Γλώσσα",
        "clickonsmslink":"Χρησιμοποιήστε το σύνδεσμο που λάβατε με SMS",
        "registersuccess":"Επιτυχής εγγραφή για τις",
        "unregistersuccess":"Επιτυχής διαγραφή από τις",
        "confirmation":"Επιβεβαίωση",
        "confexaminedon":"Επιβεβαιώστε ότι θέλετε να εξεταστείτε το/την",
        "confexaminedonnote":"",
        "confunregisterfrom":"Επιβεβαιώστε ότι θέλετε ακυρώσετε την εγγραφή σας για τις",
        "examined":"Εξετάστηκε",
        "registeredfor":"Προγραμματισμένη εξέταση στις",
        "notregisteredfor":"Δεν έχετε εγγραφεί για να εξεταστείτε",
        "license":"Αρ. Άδειας",
        "expires":"Λήγει",
        "personaldetails":"Προσωπικά στοιχεία",
        "status":"Κατάσταση",
        "instructionsprefix":"Παρακαλούμε διαβάστε σημαντικές οδηγίες σχετικά με εξετάσεις",
        "instructions":"Οδηγίες εξετάσεων",
        "usernotfound":"Δεν βρέθηκαν στοιχεία του χρήστη",
        "nextaction":"Επόμενο Βήμα",
        "registertobeexamined":"Εγγραφείτε για να εξεταστείτε μια από τις πιο κάτω ημερομηνίες",
        "availableseats":"Ελεύθερες θέσεις",
        "register":"Εγγραφη",
        "cantmakeit":"Δεν θα τα καταφέρετε;",
        "cantmakeittext":"Αν δεν θα καταφέρετε να παρευρεθείτε, πρέπει να ακυρώσετε την εγγραφή σας έγκαιρα. Διαφορετικά θα θεωρηθεί ότι αποτύχατε στις εξετάσεις και θα πρέπει να ξαναπληρώσετε και να αιτηθείτε εκ νέου.",
        "unregister":"Ακύρωση",
        "nodates":"Δεν υπάρχουν διαθέσιμες θέσεις",
        "nodatestext":"Οι διαθέσιμες θέσεις έχουν εξαντληθεί. Θα ανακοινωθούν σύντομα νέες ημερομηνίες εξετάσεων και θα ειδοποιηθείτε με SMS.",
        "moreinfoemail":"Για περισσότερες πληροφορίες στείλτε email στο:",
        "orvisitwebsite":"η επισκεφτείτε την ιστιοσελίδα μας",
    }
}

export default Lang;

//Lang[userLang].orvisitwebsite